import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Breadcrumb from '../../menus/FleetBreadcrum'
import Fleet from '../../components/Fleet'

const StandardpickupEn = props => (
  <div className="page  Standard Pick Up">
  <Helmet
          title={` Standard Pick Up Vehicles for Rent | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals. ',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href:
                './es/fleet/standard_pick_up',
            },
          ]}
        />
    <Breadcrumb
      lang={props.pathContext.langKey}
      currentPage={' Standard Pick Up Cars'}
    />
    <h1> Standard Pick Up</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={16}
    />
  </div>
)

export const query = graphql`
  query StandardpickupEN {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default StandardpickupEn



// WEBPACK FOOTER //
// ./src/pages/fleet/standard_pick_up.en.js